import { getGlobalValue, GlobalStoreKeys } from "store/globalStore";
export class PriceV3Api {
  basePath: string = '/api/priceui/v3/';

  get = async (url: RequestInfo, options?: RequestInit) => {
    return await makeGet(this.basePath, url, !options ? {} : options!);
  };
  post = async (
    url: RequestInfo,
    body: string,
    options?: RequestInit,
    signal?: AbortSignal
  ) => {
    return await makePost(
      this.basePath,
      url,
      body,
      !options ? {} : options!,
      signal
    );
  };

  delete = async (url: RequestInfo, options?: RequestInit) => {
    return await makeDelete(this.basePath, url, !options ? {} : options!);
  };
  put = async (url: RequestInfo, body: string, options?: RequestInit) => {
    return await makePut(this.basePath, url, body, !options ? {} : options!);
  };
}

const makeGet = async (
  baseUrl: string,
  url: RequestInfo,
  options: RequestInit
) => {
  var result = await fetch(`${baseUrl}${url}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Occupancy-Mode': getGlobalValue<number>(GlobalStoreKeys.occupancyMode).toString(),
    },
    ...options,
  });
  var resp = await result.text();
  var json = JSON.parse(resp) as any;
  return json;
};

const makePut = async (
  baseUrl: string,
  url: RequestInfo,
  body: string,
  options: RequestInit
) => {
  var result = await fetch(`${baseUrl}${url}`, {
    method: 'PUT',
    body,
    headers: {
      'Content-Type': 'application/json',
      'Occupancy-Mode': getGlobalValue<number>(GlobalStoreKeys.occupancyMode).toString(),
    },
    ...options,
  });
  var resp = await result.text();
  if (!resp) {
    return;
  }
  var json = JSON.parse(resp) as any;
  return json;
};

const makePost = async (
  baseUrl: string,
  url: RequestInfo,
  body: string,
  options: RequestInit,
  signal?: AbortSignal
) => {
  let resp = '';
  try {
    var result = await fetch(`${baseUrl}${url}`, {
      method: 'POST',
      body,
      headers: {
        'Content-Type': 'application/json',
        'Occupancy-Mode': getGlobalValue<number>(GlobalStoreKeys.occupancyMode).toString(),
      },
      ...options,
      signal,
    });
    resp = await result.text();
  } catch (err) {
    // A superseded request is aborted on purpose, so it has no result: return
    // undefined just like an empty body does (callers already null-check it).
    // Anything else is a real failure and must stay visible.
    if ((err as { name?: string } | null)?.name === 'AbortError') {
      return;
    }
    throw err;
  }
  if (!resp) {
    return;
  }
  var json = JSON.parse(resp) as any;
  return json;
};

const makeDelete = async (
  baseUrl: string,
  url: RequestInfo,
  options: RequestInit
) => {
  var result = await fetch(`${baseUrl}${url}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Occupancy-Mode': getGlobalValue<number>(GlobalStoreKeys.occupancyMode).toString(),
    },
    ...options,
  });
  var resp = await result.text();
  var json = JSON.parse(resp) as any;
  return json;
};
